import React, { Component } from 'react';
import './MoreInformation.css';
import { Button,OverlayTrigger,Tooltip } from 'react-bootstrap';

var Translate   = require('react-translate-component');


export default class ServiceStatus extends Component {
  constructor(props) {
    super(props);
    this.tooltip = (
      <Tooltip id="tooltip"><Translate component="span" content={this.props.info} /></Tooltip>
    );
  }

  render() {
    return (
        <OverlayTrigger trigger="click" placement="left" overlay={this.tooltip}>
          <Button className="more_info">?</Button>
        </OverlayTrigger>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/MoreInformation/MoreInformation.jsx
 **/